import { SVLabeledText } from '@/components/core';
import { BrandingThemeItem } from '@/types/brandingThemes';
import { formatDateTimeFromUTC } from '@/utils/date';
import { Card, Typography, Grid } from '@mui/material';

type ThemeNameProps = {
  brandingTheme: BrandingThemeItem;
};

export default function ThemeNameView({ brandingTheme }: ThemeNameProps) {
  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Theme Name
      </Typography>
      <Grid container>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVLabeledText
            label="Last Updated At"
            text={formatDateTimeFromUTC(brandingTheme.lastUpdatedAt)}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVLabeledText
            label="Last Updated By"
            text={brandingTheme.lastUpdatedBy.fullName}
          />
        </Grid>
      </Grid>
    </Card>
  );
}
